// import { useEffect, useState } from "react";
// import { FiTrash2, FiPlus, FiX, FiEdit } from "react-icons/fi";
// import { ToastContainer, toast } from 'react-toastify';
// import axios from "axios";
// import { BASE_URL } from "./baseUrl";

// const defaultPlan = {
//   name: "",
//   price: 0,
//   numberOfSigns: 0,
//   numberOfEmails: 0,
//   billingCycle: "monthly"
// };

// const formatGMD = (value) => {
//   const amount = Number(value) || 0;
//   return `D${amount.toFixed(2)}`;
// };

// function PlanDashboard() {
//   const [monthlyPlans, setMonthlyPlans] = useState([]);
//   const [yearlyPlans, setYearlyPlans] = useState([]);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [editingPlan, setEditingPlan] = useState(null);
//   const [formData, setFormData] = useState(defaultPlan);

//   useEffect(() => {
//     fetchPlans();
//   }, []);
//   const fetchPlans = async () => {
//     try {
//       const token = localStorage.getItem('token');
//       const res = await axios.get(`${BASE_URL}/get-plans`, {
//         headers: { authorization: `Bearer ${token}` }
//       });
      
//       const plans = res.data.plans.map(plan => ({
//         ...plan,
//         price: plan.price?.$numberDecimal ? parseFloat(plan.price.$numberDecimal) : plan.price
//       })); 
      
//       setMonthlyPlans(plans.filter(p => p.billingCycle === 'monthly'));
//       setYearlyPlans(plans.filter(p => p.billingCycle === 'yearly'));
//     } catch (error) {
//       handleError(error, "Failed to load plans");
//     }
//   };

//   const handleSubmit = async () => {
//     try {
//       if(formData.name.length==0){
//         toast.error("Please enter name",{containerId:"plans"})
//         return
//       }else if(formData.numberOfSigns==0){
//         toast.error("Please enter number of signatures",{containerId:"plans"})
//         return
//       }else if(formData.numberOfEmails==0){
//         toast.error("Please enter number of emails",{containerId:"plans"})
//         return;
//       }else if(formData.billingCycle.length==0){
//         toast.error("Please enter billing cycle",{containerId:"plans"})
//         return;
//       }
//       const token = localStorage.getItem('token');
//       const url = editingPlan 
//         ? `${BASE_URL}/update-plan/${editingPlan._id}`
//         : `${BASE_URL}/create-plan`;

//       const method = editingPlan ? 'patch' : 'post';

//       const res = await axios[method](url, formData, {
//         headers: { authorization: `Bearer ${token}` }
//       });

//       toast.success(res.data.message, { containerId: "plans" });
//       resetForm();
//       fetchPlans();
//     } catch (error) {
//       handleError(error, "Operation failed");
//     }
//   };

//   const deletePlan = async (id) => {
//     try {
//       const token = localStorage.getItem('token');
//       await axios.delete(`${BASE_URL}/delete-plan/${id}`, {
//         headers: { authorization: `Bearer ${token}` }
//       });
//       toast.success("Plan deleted successfully", { containerId: "plans" });
//       fetchPlans();
//     } catch (error) {
//       handleError(error, "Delete failed");
//     }
//   };

//   const handleEditClick = (plan) => {
//     setEditingPlan(plan);
//     setFormData({
//       ...plan,
//       price: plan.price?.$numberDecimal ? parseFloat(plan.price.$numberDecimal) : plan.price
//     });
//     setIsModalOpen(true);
//   };
  
//   const resetForm = () => {
//     setFormData(defaultPlan);
//     setEditingPlan(null);
//     setIsModalOpen(false);
//   };
//   const handleError = (error, defaultMsg) => {
//     console.error(error);
//     const message = error.response?.data?.error || defaultMsg;
//     toast.error(message, { containerId: "plans" });
//   };


//   const renderPlanCard = (plan) => (
//     <div key={plan._id} className="bg-white rounded-lg p-4 shadow-md mb-4">
//       <div className="flex justify-between items-start">
//         <div>
//           <h3 className="text-xl font-bold">{plan.name}</h3>
//           <p className="text-2xl my-2">
//             {formatGMD(plan.price)}
//           </p>
//           <div className="text-gray-600">
//             <p>{plan.numberOfSigns} signatures</p>
//             <p>{plan.numberOfEmails} emails</p>
//           </div>
//         </div>
//         <div className="flex gap-2">
//           <button
//             onClick={() => handleEditClick(plan)}
//             className="text-blue-500 hover:text-blue-700"
//           >
//             <FiEdit size={20} />
//           </button>
//           <button
//             onClick={() => deletePlan(plan._id)}
//             className="text-red-500 hover:text-red-700"
//           >
//             <FiTrash2 size={20} />
//           </button>
//         </div>
//       </div>
//     </div>
//   );

//   return (
//     <div className="min-h-screen bg-gray-50 p-8">
//       <ToastContainer containerId="plans" />
//       <div className="max-w-6xl mx-auto">
//         <div className="flex justify-between items-center mb-8">
//           <h1 className="text-3xl font-bold">Subscription Plans</h1>
//           <button
//             onClick={() => setIsModalOpen(true)}
//             className="bg-blue-600 text-white px-4 py-2 rounded-lg flex items-center gap-2"
//           >
//             <FiPlus /> Add Plan
//           </button>
//         </div>

//         <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//           <div>
//             <h2 className="text-2xl font-semibold mb-4">Monthly Plans</h2>
//             {monthlyPlans.map(renderPlanCard)}
//             {monthlyPlans.length < 4 && (
//               <div className="text-gray-500 text-center">
//                 {4 - monthlyPlans.length} monthly slots available
//               </div>
//             )}
//           </div>

//           <div>
//             <h2 className="text-2xl font-semibold mb-4">Yearly Plans</h2>
//             {yearlyPlans.map(renderPlanCard)}
//             {yearlyPlans.length < 4 && (
//               <div className="text-gray-500 text-center">
//                 {4 - yearlyPlans.length} yearly slots available
//               </div>
//             )}
//           </div>
//         </div>

//         {isModalOpen && (
//           <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
//             <div className="bg-white rounded-lg p-6 w-96">
//               <div className="flex justify-between items-center mb-4">
//                 <h2 className="text-xl font-bold">
//                   {editingPlan ? "Edit Plan" : "New Plan"}
//                 </h2>
//                 <button onClick={resetForm} className="text-gray-500">
//                   <FiX size={24} />
//                 </button>
//               </div>

//               <div className="space-y-4">
//                 <div>
//                   <label className="block mb-2">Plan Name</label>
//                   <input
//                     type="text"
//                     value={formData.name}
//                     onChange={(e) => setFormData({...formData, name: e.target.value})}
//                     className="w-full p-2 border rounded"
//                   />
//                 </div>

//                 <div>
//                   <label className="block mb-2">Price (GMD)</label>
//                   <input
//                     type="number"
//                     value={formData.price}
//                     onChange={(e) => setFormData({...formData, price: e.target.value})}
//                     className="w-full p-2 border rounded"
//                     min="0"
//                   />
//                 </div>

//                 <div>
//                   <label className="block mb-2">Number of Signatures</label>
//                   <input
//                     type="number"
//                     value={formData.numberOfSigns}
//                     onChange={(e) => setFormData({...formData, numberOfSigns: e.target.value})}
//                     className="w-full p-2 border rounded"
//                     min="0"
//                   />
//                 </div>

//                 <div>
//                   <label className="block mb-2">Number of Emails</label>
//                   <input
//                     type="number"
//                     value={formData.numberOfEmails}
//                     onChange={(e) => setFormData({...formData, numberOfEmails: e.target.value})}
//                     className="w-full p-2 border rounded"
//                     min="0"
//                   />
//                 </div>

//                 <div>
//                   <label className="block mb-2">Billing Cycle</label>
//                   <select
//                     value={formData.billingCycle}
//                     onChange={(e) => setFormData({...formData, billingCycle: e.target.value})}
//                     className="w-full p-2 border rounded"
//                   >
//                     <option value="monthly">Monthly</option>
//                     <option value="yearly">Yearly</option>
//                   </select>
//                 </div>

//                 <div className="flex justify-end gap-4">
//                   <button
//                     onClick={resetForm}
//                     className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     onClick={handleSubmit}
//                     className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
//                   >
//                     {editingPlan ? "Save Changes" : "Create Plan"}
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default PlanDashboard;

import { useEffect, useMemo, useState } from "react";
import {
  FiTrash2,
  FiPlus,
  FiX,
  FiEdit,
  FiLayers,
  FiCalendar,
  FiFileText,
  FiMail,
  FiDollarSign,
} from "react-icons/fi";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import { BASE_URL } from "./baseUrl";
import "react-toastify/dist/ReactToastify.css";

const defaultPlan = {
  name: "",
  price: 0,
  numberOfSigns: 0,
  numberOfEmails: 0,
  billingCycle: "monthly",
};

const formatGMD = (value) => {
  const amount = Number(value) || 0;
  return `D${amount.toFixed(2)}`;
};

function PlanDashboard() {
  const [monthlyPlans, setMonthlyPlans] = useState([]);
  const [yearlyPlans, setYearlyPlans] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingPlan, setEditingPlan] = useState(null);
  const [formData, setFormData] = useState(defaultPlan);

  useEffect(() => {
    fetchPlans();
  }, []);

  const allPlans = useMemo(
    () => [...monthlyPlans, ...yearlyPlans],
    [monthlyPlans, yearlyPlans]
  );

  const fetchPlans = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${BASE_URL}/get-plans`, {
        headers: { authorization: `Bearer ${token}` },
      });

      const plans = (res.data.plans || []).map((plan) => ({
        ...plan,
        price: plan.price?.$numberDecimal
          ? parseFloat(plan.price.$numberDecimal)
          : plan.price,
      }));

      setMonthlyPlans(plans.filter((p) => p.billingCycle === "monthly"));
      setYearlyPlans(plans.filter((p) => p.billingCycle === "yearly"));
    } catch (error) {
      handleError(error, "Failed to load plans");
    }
  };

  const handleSubmit = async () => {
    try {
      if (formData.name.trim().length === 0) {
        toast.error("Please enter plan name", { containerId: "plans" });
        return;
      }
      if (Number(formData.price) <= 0) {
        toast.error("Please enter a valid price", { containerId: "plans" });
        return;
      }
      if (Number(formData.numberOfSigns) <= 0) {
        toast.error("Please enter number of signatures", {
          containerId: "plans",
        });
        return;
      }
      if (Number(formData.numberOfEmails) <= 0) {
        toast.error("Please enter number of emails", {
          containerId: "plans",
        });
        return;
      }
      if (!formData.billingCycle) {
        toast.error("Please select billing cycle", {
          containerId: "plans",
        });
        return;
      }

      const token = localStorage.getItem("token");
      const url = editingPlan
        ? `${BASE_URL}/update-plan/${editingPlan._id}`
        : `${BASE_URL}/create-plan`;

      const method = editingPlan ? "patch" : "post";

      const payload = {
        ...formData,
        price: Number(formData.price),
        numberOfSigns: Number(formData.numberOfSigns),
        numberOfEmails: Number(formData.numberOfEmails),
      };

      const res = await axios[method](url, payload, {
        headers: { authorization: `Bearer ${token}` },
      });

      toast.success(res.data.message || "Saved successfully", {
        containerId: "plans",
      });

      resetForm();
      fetchPlans();
    } catch (error) {
      handleError(error, "Operation failed");
    }
  };

  const deletePlan = async (id) => {
    try {
      const token = localStorage.getItem("token");
      await axios.delete(`${BASE_URL}/delete-plan/${id}`, {
        headers: { authorization: `Bearer ${token}` },
      });
      toast.success("Plan deleted successfully", { containerId: "plans" });
      fetchPlans();
    } catch (error) {
      handleError(error, "Delete failed");
    }
  };

  const handleEditClick = (plan) => {
    setEditingPlan(plan);
    setFormData({
      ...plan,
      price: plan.price?.$numberDecimal
        ? parseFloat(plan.price.$numberDecimal)
        : Number(plan.price || 0),
    });
    setIsModalOpen(true);
  };

  const resetForm = () => {
    setFormData(defaultPlan);
    setEditingPlan(null);
    setIsModalOpen(false);
  };

  const handleError = (error, defaultMsg) => {
    console.error(error);
    const message = error?.response?.data?.error || defaultMsg;
    toast.error(message, { containerId: "plans" });
  };

  const summaryCards = [
    {
      label: "Total plans",
      value: allPlans.length,
      icon: FiLayers,
      accent: "from-violet-500/20 to-fuchsia-500/20 text-violet-200",
    },
    {
      label: "Monthly plans",
      value: monthlyPlans.length,
      icon: FiCalendar,
      accent: "from-sky-500/20 to-cyan-500/20 text-sky-200",
    },
    {
      label: "Yearly plans",
      value: yearlyPlans.length,
      icon: FiFileText,
      accent: "from-emerald-500/20 to-teal-500/20 text-emerald-200",
    },
    {
      label: "Highest price",
      value: allPlans.length
        ? formatGMD(
            Math.max(...allPlans.map((plan) => Number(plan.price) || 0))
          )
        : "D0.00",
      icon: FiDollarSign,
      accent: "from-amber-500/20 to-orange-500/20 text-amber-200",
    },
  ];

  const renderPlanCard = (plan) => (
    <div
      key={plan._id}
      className="rounded-3xl border border-white/10 bg-white/5 p-5 shadow-lg shadow-black/10 backdrop-blur-sm"
    >
      <div className="flex items-start justify-between gap-4">
        <div>
          <div className="inline-flex rounded-full border border-white/10 bg-white/5 px-3 py-1 text-xs font-medium uppercase tracking-[0.16em] text-slate-300">
            {plan.billingCycle}
          </div>

          <h3 className="mt-3 text-xl font-semibold text-white">
            {plan.name}
          </h3>

          <p className="mt-2 text-3xl font-bold text-white">
            {formatGMD(plan.price)}
          </p>

          <div className="mt-4 grid gap-3 sm:grid-cols-2">
            <div className="rounded-2xl border border-white/10 bg-slate-900/40 px-4 py-3">
              <div className="text-xs uppercase tracking-[0.14em] text-slate-400">
                Signatures
              </div>
              <div className="mt-1 text-lg font-semibold text-slate-100">
                {plan.numberOfSigns}
              </div>
            </div>

            <div className="rounded-2xl border border-white/10 bg-slate-900/40 px-4 py-3">
              <div className="text-xs uppercase tracking-[0.14em] text-slate-400">
                Emails
              </div>
              <div className="mt-1 text-lg font-semibold text-slate-100">
                {plan.numberOfEmails}
              </div>
            </div>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <button
            onClick={() => handleEditClick(plan)}
            className="inline-flex h-10 w-10 items-center justify-center rounded-2xl border border-white/10 bg-white/5 text-slate-200 transition hover:border-violet-400/30 hover:bg-violet-500/10 hover:text-white"
            title="Edit plan"
          >
            <FiEdit />
          </button>

          <button
            onClick={() => deletePlan(plan._id)}
            className="inline-flex h-10 w-10 items-center justify-center rounded-2xl border border-white/10 bg-white/5 text-slate-200 transition hover:border-red-400/30 hover:bg-red-500/10 hover:text-white"
            title="Delete plan"
          >
            <FiTrash2 />
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="space-y-8">
      <ToastContainer containerId="plans" position="top-right" autoClose={2500} />

      <section className="rounded-[32px] border border-white/10 bg-white/5 p-6 shadow-xl shadow-black/10 backdrop-blur-sm lg:p-8">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
          <div>
            <div className="inline-flex rounded-full border border-violet-400/20 bg-violet-400/10 px-4 py-2 text-sm font-medium text-violet-200">
              Platform pricing controls
            </div>

            <h1 className="mt-4 text-3xl font-semibold tracking-tight text-white lg:text-4xl">
              Subscription Plans
            </h1>

            <p className="mt-3 max-w-2xl text-slate-300">
              Create, update, and manage the plans available across the E-Lex
              platform.
            </p>
          </div>

          <button
            onClick={() => setIsModalOpen(true)}
            className="inline-flex items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-violet-500 via-fuchsia-500 to-indigo-500 px-5 py-3 text-sm font-semibold text-white shadow-lg shadow-violet-900/30 transition hover:scale-[1.01]"
          >
            <FiPlus />
            Add Plan
          </button>
        </div>

        <div className="mt-8 grid gap-4 md:grid-cols-2 xl:grid-cols-4">
          {summaryCards.map((card) => {
            const Icon = card.icon;

            return (
              <div
                key={card.label}
                className="rounded-3xl border border-white/10 bg-slate-950/40 p-5"
              >
                <div
                  className={`inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-gradient-to-br ${card.accent}`}
                >
                  <Icon className="text-lg" />
                </div>

                <div className="mt-4 text-sm text-slate-400">{card.label}</div>
                <div className="mt-1 text-2xl font-semibold text-white">
                  {card.value}
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <section className="grid gap-6 xl:grid-cols-2">
        <div className="rounded-[32px] border border-white/10 bg-white/5 p-6 shadow-xl shadow-black/10 backdrop-blur-sm">
          <div className="mb-5 flex items-center justify-between">
            <div>
              <h2 className="text-2xl font-semibold text-white">
                Monthly Plans
              </h2>
              <p className="mt-1 text-sm text-slate-400">
                Active monthly plan configurations
              </p>
            </div>

            <div className="rounded-full border border-white/10 bg-white/5 px-3 py-1.5 text-sm text-slate-300">
              {monthlyPlans.length}/4 slots
            </div>
          </div>

          <div className="space-y-4">
            {monthlyPlans.length ? (
              monthlyPlans.map(renderPlanCard)
            ) : (
              <div className="rounded-3xl border border-dashed border-white/10 bg-slate-950/30 p-8 text-center text-slate-400">
                No monthly plans yet.
              </div>
            )}
          </div>
        </div>

        <div className="rounded-[32px] border border-white/10 bg-white/5 p-6 shadow-xl shadow-black/10 backdrop-blur-sm">
          <div className="mb-5 flex items-center justify-between">
            <div>
              <h2 className="text-2xl font-semibold text-white">
                Yearly Plans
              </h2>
              <p className="mt-1 text-sm text-slate-400">
                Active yearly plan configurations
              </p>
            </div>

            <div className="rounded-full border border-white/10 bg-white/5 px-3 py-1.5 text-sm text-slate-300">
              {yearlyPlans.length}/4 slots
            </div>
          </div>

          <div className="space-y-4">
            {yearlyPlans.length ? (
              yearlyPlans.map(renderPlanCard)
            ) : (
              <div className="rounded-3xl border border-dashed border-white/10 bg-slate-950/30 p-8 text-center text-slate-400">
                No yearly plans yet.
              </div>
            )}
          </div>
        </div>
      </section>

      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/75 p-4 backdrop-blur-sm">
          <div className="w-full max-w-xl rounded-[32px] border border-white/10 bg-slate-900/95 p-6 shadow-2xl shadow-black/40">
            <div className="mb-6 flex items-start justify-between gap-4">
              <div>
                <div className="inline-flex rounded-full border border-violet-400/20 bg-violet-400/10 px-3 py-1 text-xs font-semibold uppercase tracking-[0.16em] text-violet-200">
                  {editingPlan ? "Edit Plan" : "New Plan"}
                </div>
                <h2 className="mt-3 text-2xl font-semibold text-white">
                  {editingPlan
                    ? "Update subscription plan"
                    : "Create subscription plan"}
                </h2>
              </div>

              <button
                onClick={resetForm}
                className="inline-flex h-10 w-10 items-center justify-center rounded-2xl border border-white/10 bg-white/5 text-slate-300 transition hover:bg-white/10 hover:text-white"
              >
                <FiX />
              </button>
            </div>

            <div className="grid gap-4 md:grid-cols-2">
              <div className="md:col-span-2">
                <label className="mb-2 block text-sm font-medium text-slate-200">
                  Plan name
                </label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                  className="w-full rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-white outline-none placeholder:text-slate-500 focus:border-violet-400/50 focus:ring-4 focus:ring-violet-500/10"
                  placeholder="Business Pro"
                />
              </div>

              <div>
                <label className="mb-2 block text-sm font-medium text-slate-200">
                  Price (GMD)
                </label>
                <input
                  type="number"
                  min="0"
                  value={formData.price}
                  onChange={(e) =>
                    setFormData({ ...formData, price: e.target.value })
                  }
                  className="w-full rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-white outline-none placeholder:text-slate-500 focus:border-violet-400/50 focus:ring-4 focus:ring-violet-500/10"
                />
              </div>

              <div>
                <label className="mb-2 block text-sm font-medium text-slate-200">
                  Billing cycle
                </label>
                <select
                  value={formData.billingCycle}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      billingCycle: e.target.value,
                    })
                  }
                  className="w-full rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-white outline-none focus:border-violet-400/50 focus:ring-4 focus:ring-violet-500/10"
                >
                  <option className="bg-slate-900" value="monthly">
                    Monthly
                  </option>
                  <option className="bg-slate-900" value="yearly">
                    Yearly
                  </option>
                </select>
              </div>

              <div>
                <label className="mb-2 block text-sm font-medium text-slate-200">
                  Number of signatures
                </label>
                <input
                  type="number"
                  min="0"
                  value={formData.numberOfSigns}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      numberOfSigns: e.target.value,
                    })
                  }
                  className="w-full rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-white outline-none focus:border-violet-400/50 focus:ring-4 focus:ring-violet-500/10"
                />
              </div>

              <div>
                <label className="mb-2 block text-sm font-medium text-slate-200">
                  Number of emails
                </label>
                <input
                  type="number"
                  min="0"
                  value={formData.numberOfEmails}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      numberOfEmails: e.target.value,
                    })
                  }
                  className="w-full rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-white outline-none focus:border-violet-400/50 focus:ring-4 focus:ring-violet-500/10"
                />
              </div>
            </div>

            <div className="mt-6 flex justify-end gap-3">
              <button
                onClick={resetForm}
                className="rounded-2xl border border-white/10 bg-white/5 px-5 py-3 text-sm font-medium text-slate-200 transition hover:bg-white/10"
              >
                Cancel
              </button>

              <button
                onClick={handleSubmit}
                className="rounded-2xl bg-gradient-to-r from-violet-500 via-fuchsia-500 to-indigo-500 px-5 py-3 text-sm font-semibold text-white shadow-lg shadow-violet-900/30 transition hover:scale-[1.01]"
              >
                {editingPlan ? "Save Changes" : "Create Plan"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default PlanDashboard;